import { render } from "./CrudCliente.vue?vue&type=template&id=3b3e87e0"
import script from "./CrudCliente.vue?vue&type=script&lang=ts"
export * from "./CrudCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script